var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('ul',_vm._l((_vm.list),function(item){return _c('li',{key:item.cat_id,class:_vm.activeIndex === item.cat_id ? 'select' : '',on:{"click":function($event){return _vm.select(item.cat_id, 2)}}},[_vm._v(" "+_vm._s(item.cat_name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }